<script>
import TileWMS from 'ol/source/TileWMS'

export default {
  name: 'ol-source-tilewms',

  inject: ['getLayer'],

  props: {
    layers: {
      type: String,
      required: true
    },

    filter: {
      type: String
    },

    crossOrigin: {
      type: String,
      default: 'Anonymous'
    },
    styles: {
      type: String,
      required: '',
    },
  },

  watch: {
    filter (cqlFilter) {
      if (cqlFilter.length) {
        const params = this.tilewms.getParams()
        this.tilewms.updateParams({ ...params,styles:this.styles,  CQL_FILTER: cqlFilter })
      }
    },

    layers (layers) {
      this.tilewms.updateParams({ layers, styles:this.styles, VERSION: '1.1.0', FORMAT: 'image/png' })
    }
  },

  data () {
    return {
      tilewms: null
    }
  },

  created () {
    const params = {
      layers: this.layers,
      VERSION: '1.1.0',
      FORMAT: 'image/png',
      STYLES:this.styles,
      // exceptions: 'application/vnd.ogc.se_inimage'
    }
    this.filter && (params.CQL_FILTER = this.filter)
    this.tilewms = new TileWMS({
      url: process.env.VUE_APP_WMS,
      crossOrigin: this.crossOrigin,
      params
    })

    this.getLayer(layer => {
      layer.setSource(this.tilewms)
    })
  },

  beforeDestroy () {
    this.tilewms = null
  },

  render () {
    return null
  }
}
</script>
